import Link from 'next/link'
import { memo } from 'react'

import { PRODUCT_URL } from '@/shared/lib/const/env'

import cl from './variants-group.module.scss'

type TCrossLink = {
	kod: string
	value: string
	label: string
	is_current: boolean
	hash: string
	in_stock: string
}

export type VariantsGroupProps = {
	groupName: string
	variants: TCrossLink[]
}

export const VariantsGroup = memo(
	({ groupName, variants }: VariantsGroupProps): JSX.Element => (
		<>
			<span className={cl.productVariantsTitle}>{groupName}</span>
			{variants.map(({ kod, value, is_current, hash, in_stock }) => {
				const isOutOfStock = in_stock === 'HIDE_BUY' || in_stock === 'ARCHIVE'
				return (
					<Link
						prefetch={false}
						href={PRODUCT_URL + kod}
						key={hash}
						className={`${cl.link} ${is_current ? cl.current : ''} ${isOutOfStock ? cl.outOfStock : ''}`}>
						{value}
					</Link>
				)
			})}
		</>
	)
)
